import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";

export default {
  name: "payments",
  components: { dateField },
  data: function () {
    return {
      countFilter: 1,
      ReleaseDataAux: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      filter: {
        Identity: null,
        Id: null,
        Name: null,
        ReleaseDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        TipoDePagamento: "Merchant",
        StatusDoPagamento: "",
        SituacaoPagamento: "",
        IdGateway: ""
      },      
      payments: [],
      paymentsType: '',
      labelIdentity: "CPF/CNPJ",
      labelName: "Favorecido",
      loadingList: false,
      loadingReport: false,
      loadingAmounts: false,
      loadingLiberacaoRemessa: false,
      remessaEstaDisponivel: false,
      queryDateTime: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      valorPorGateway: {
        3: 'R$ 0.00',
        28: 'R$ 0.00'
      },
      valuesToPay: {
        Parceiros: { 
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },        
        Merchant: {
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },
        Contratos: {           
            EnviadosBanco: 0.0
        },
        TED: 0.0
      }
    };
  },
  computed: {
    Cards() {
      return [
        {
          label: "TED",
          value: this.CentsToCurrency(
            this.valuesToPay.TED
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Comissões",
          value: this.CentsToCurrency(
            this.valuesToPay.Parceiros.EnviadosBanco
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Merchants",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.EnviadosBanco),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Contratos",
          value: this.CentsToCurrency(this.valuesToPay.Contratos.EnviadosBanco),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Total a Banco",
          value: this.CentsToCurrency(
              (this.valuesToPay.Contratos.EnviadosBanco +
              this.valuesToPay.Merchant.EnviadosBanco  +
              this.valuesToPay.Parceiros.EnviadosBanco +
              this.valuesToPay.TED) || 0
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Repasses Bloqueados",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Bloqueados),
          style: "payment-deny",
          showIcon: false,
        },
        {
          label: "Comissões Reagendados",
          value: this.CentsToCurrency(this.valuesToPay.Parceiros.Reagendamentos),
          style: "payment-absent",
          showIcon: false,
        },
        {
          label: "Merchants Reagendados",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Reagendamentos),
          style: "payment-absent",
          showIcon: false,
        },
        {
          label: "Complementares",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Complementares),
          style: "payment-info",
          showIcon: true,
          title: "Os valores complementares são estimativas e podem variar."
        },
        {
          label: "Previsão do Dia",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Previstos),
          style: "payment-info",
          showIcon: true,
          title: "Os valores previstos são estimativas e podem variar."
        }
      ];
    },
    infoBancosPorId(){
      return {
        3:{
          ImgIcone: require("@/assets/images/bank_0001.png"),
          ImgDetalhada: require("@/assets/images/logos/banco-do-brasil-horizontal.jpg")
        },
        28:{
          ImgIcone:require("@/assets/images/bank_0237.png"),
          ImgDetalhada: require("@/assets/images/logos/bradesco-horizontal.png")
        }
      }
    }
  },
  watch: {
    "pagination.PageNumber": function () {
      this.GetPaymentList()
    },
    "pagination.RowsPerPage": function () {
      this.GetPaymentList()
    },
  },
  mounted() {
    this.RefreshAmounts();
    this.GetPaymentList();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    CentsToCurrency(value){
      if (value == NaN || value == null || value === null || value === undefined) 
          value = 0;

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value / 100);
    },
    FormatCurrency(value) {
      return this.$options.filters.currency(value)
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");      
      this.GetPaymentList()
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let params = {
          ...this.pagination,
          ...this.filter
      };
      this.$store
        .dispatch("PaymentListReport", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    
    MergeWithDefaults: function (response, defaults) {
        let merged = Object.assign({}, defaults, response);

        for (let key in defaults) {
           if (merged[key] === null) {
               merged[key] = defaults[key];
            }
        }  
      return merged;
    },

    RefreshAmounts: function () {
      this.loadingAmounts = true;
      this.queryDateTime = null;
      let data = { "ReleaseDate": this.filter.ReleaseDate };
      this.ResetConsolidated();
      this.$store.dispatch("GetConsolidated", { params: data })
        .then((response) => {                
          this.valuesToPay = this.MergeWithDefaults(response,this.valuesToPay);
          this.queryDateTime = response.DataHoraConsulta;
          this.SetValorPorGateway(this.valuesToPay.ValorPorGateway);
          this.remessaEstaDisponivel = this.valuesToPay.RemessaDisponivel;
          console.log(this.valuesToPay);
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os favorecidos",
            error
          );
        }).finally(() => { this.loadingAmounts = false; });
    },
    ConfirmLiberarRemessa: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja liberar as remessas do Bradesco ? Essa ação não pode ser desfeita.`,
        "Confirmar",
        this.LiberarRemessa,
        i
      );
    },
    LiberarRemessa: function () {
      this.loadingLiberacaoRemessa = true;
      this.$store.dispatch("PostLiberarRemessa", { })
        .then((response) => {                
          this.remessaEstaDisponivel = !response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao tentar liberar remessa",
            error
          );
        }).finally(() => { this.loadingLiberacaoRemessa = false; });
    },
    SetValorPorGateway(listValorPorGateway){
      listValorPorGateway.forEach(element => {
        this.valorPorGateway[element.IdGateway] = this.CentsToCurrency(element.Valor);
      });
    },
    GetPaymentList: function () {
     this.countFilter = 0;
     if (hasValue(this.filter.Name))
     this.countFilter++;
     if (hasValue(this.filter.Identity))
     this.countFilter++;
     if (hasValue(this.filter.ReleaseDate))
     this.countFilter++;
     if (hasValue(this.filter.StatusDoPagamento))
     this.countFilter++;
     if (hasValue(this.filter.SituacaoPagamento))
     this.countFilter++;
     if (hasValue(this.filter.TipoDePagamento))
     this.countFilter++;
     if (hasValue(this.filter.Id))
     this.countFilter++;
    if (hasValue(this.filter.IdGateway))
     this.countFilter++;

     this.loadingList = true;
     let data = {
       ...this.pagination,
       ...this.filter
     };
     
     data.PageNumber -= 1;
     
     if(this.ReleaseDataAux != this.filter.ReleaseDate){
        console.log(this.ReleaseDataAux);
        console.log(this.filter.ReleaseDate);

        this.RefreshAmounts();
        this.ReleaseDataAux = this.filter.ReleaseDate;
     }

     this.payments = [];

     this.$store.dispatch("GetPaymentList", { params: data })  
                .then((response) => {    

                const { Dados } = Object.assign(this.valuesToPay, response) || {};
                const { Merchant, Comissao, Contratos } = Dados || {};
                const { TipoDePagamento } = this.filter || {};
                            
                const processPayments = (entity, paymentType) => {
                  if (entity && TipoDePagamento === paymentType) {
                    const dados = [
                      'EnviadosBanco', 'Previstos', 'Bloqueados', 'Reagendamentos', 
                      'Complementares', 'Desabilitados'
                    ]
                      .map(key => entity[key])
                      .find(item => item); 
                  
                    if (dados && dados.Pagamentos.length > 0) {
                      this.payments = dados.Pagamentos;
                    }
                    const { QuantidadeTotalRegistros } = dados || 0
                    if (QuantidadeTotalRegistros) {
                      this.pagination.TotalItems = QuantidadeTotalRegistros;
                    }
                    console.log(this.pagination.TotalItems);

                    this.paymentsType = paymentType;
                  }
                };

    processPayments(Merchant, 'Merchant');
    processPayments(Comissao, 'Parceiros');
    processPayments(Contratos, 'Contratos');

  })
  .catch((error) => {
    this.$makeToast(
      undefined,
      "danger",
      "Erro ao listar os favorecidos",
      error
    );
  })
  .finally(() => {
    this.loadingList = false;
    this.loadingAmounts = false;
  });

    },
    ResetFilter: function () {
      this.countFilter = 2;
      this.filter = {
        Identity: null,
        Id: null,
        Name: null,
        ReleaseDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        TipoDePagamento: "Merchant",
        StatusDoPagamento: "",
        SituacaoPagamento: "",
        IdGateway: ""
      };

      this.RefreshAmounts();
      this.GetPaymentList();
    },
    ResetConsolidated: function() {
      this.valuesToPay = {
        Parceiros: {
            Reagendamentos: 0.0,                  
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco:0.0
        },
        Merchant: {
            Reagendamentos: 0.0,                  
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },
        Contratos: {           
            EnviadosBanco: 0
        },
        TED: 0
      }
    },
    GetStyle: function(situacaoRepasse) {
      let styleParaSituacao = {
        "Liberado": "payment-success",
        "Bloqueado": "payment-deny",
        "Dados Bancários Ausentes": "payment-absent",
        "Desabilitado": "payment-alert"
      }

      return styleParaSituacao[situacaoRepasse] || "payment-success";
    }   
  },
};


// WEBPACK FOOTER //
// ./src/components/pages/Payments/payments.js